module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAANBJREFUWEftlS0OAjEQRr8nCMcAS8AiSTgCPydAEu6zmhPsHoEEicCxGq6ABDFkBQmQjiGZ7Io2qezM62u/FrU8aLm/MkA20C0DZnaQNA9Oxh7YvHt8GTCzk6RpMMAFmHgAQ0nNjBxn4J4EiOzq1e7WJcwGGgNmNog0Adw+6//GsJS0jASQVAJrL4aVpEUwQAWs3BiaWeg7AFzdIwjeebJ8fge6ZcDM+pJmwXfhCDy8GNaSRsEANTD2AApJ2wTA80+oXmJdAezyd5wNZAOdMfACwkAxIeXtwBcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/menu.png
// module id = Jvgh
// module chunks = 134